import Emit from "./emit";
import List from "./list";
import Settings from "./config";
import Enable from "./enable";

import { mapTest } from "../../../components/pages/products/map.test";

export const paths = [
  {
    path: "/nfse/enable",
    component: Enable,
  },
  {
    path: "/nfse/settings",
    component: Settings,
  },
  {
    path: "/nfse/list",
    component: List,
  },
  {
    path: "/nfse",
    component: Emit,
  },
];

const enabledTree = [
  {
    testId: mapTest.sidebar.nfse.emit,
    icon: "file-signature",
    path: "/nfse",
    label: "Emitir NFS-e",
  },
  {
    testId: mapTest.sidebar.nfse.list,
    icon: "list",
    path: "/nfse/list",
    label: "Notas Emitidas",
  },
  {
    testId: mapTest.sidebar.nfse.settings,
    icon: "cog",
    path: "/nfse/settings",
    label: "Configurações",
  },
];

export const NFSERouters = {
  icon: "file-invoice",
  testId: mapTest.sidebar.nfse.index,
  path: "/nfse",
  label: "NFSe",
  tree: enabledTree,
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/routers.js